import { isEmpty } from '@backmarket/utils/object/isEmpty'

import type { ResolutionOption } from '~/api/resolution-engine/types/GetResolutionOptions.types'
import { useCreateShipmentApi } from '~/scopes/customer-care/resolution/composables/useCreateShipmentApi'

import type { MachineContext } from '../ResolutionFlow.machine.types'

export async function createShipment({
  customerInput,
  diagnosisV2CustomerIssues,
  orderlineId,
  shipment,
}: MachineContext) {
  if (!isEmpty(shipment)) {
    return {
      shipment,
    }
  }
  const payload = await useCreateShipmentApi({
    declaredProblem: {
      declaredWarrantyState: customerInput.declaredWarrantyState,
      orderlineId,
      customerIssues: diagnosisV2CustomerIssues,
    },
    resolutionOption: (
      customerInput?.resolutionOptions as ResolutionOption[]
    )?.[0],
  })

  if (!isEmpty(payload)) {
    return payload
  }

  return Promise.reject(new Error('No shipment'))
}
